import {useEffect, RefObject} from 'react';

import {EEventType} from 'coreClasses/events/IEvents';

import {DATALAYER_CONFIGS} from 'brandConstants';
import {useTrackPromotionEvent} from './useTrackPromotionEvent';

export const usePromotionViewEvent = (ref: RefObject<HTMLElement>, link: string) => {
	const {trackPromotionEvent} = useTrackPromotionEvent();

	useEffect(() => {
		const {trackedQueryParameters} = DATALAYER_CONFIGS?.promotionEvent || {};
		const element = ref?.current;

		if (!element || !link) {
			return;
		}

		const includesTrackedParameter = trackedQueryParameters.some((parameter) => link.includes(parameter));

		if (!includesTrackedParameter) {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						trackPromotionEvent(link, EEventType.VIEW_BRAND_PROMOTION);
						observer.disconnect();
					}
				});
			},
			{threshold: 0.5},
		);

		observer.observe(element);

		return () => {
			observer.disconnect();
		};
	}, [ref, link]);
};
